<template>
  <a-tooltip :title="title">
    <a-button
      class="icon-btn"
      @click="iconClick"
      :loading="loading"
      v-bind="$attrs"
    >
      <slot>
        <icon-node v-if="!loading" :style="iconStyle" />
      </slot>
    </a-button>
  </a-tooltip>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import {
  ArrowLeftOutlined,
  UndoOutlined,
  DownloadOutlined,
  SettingOutlined
} from "@ant-design/icons-vue";

const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  icon: {
    type: String
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const iconNode = computed(() => {
  let icon;
  switch (props.icon) {
    case "download":
      icon = DownloadOutlined;
      break;
    case "reset":
      icon = UndoOutlined;
      break;
    case "back":
      icon = ArrowLeftOutlined;
      break;
    case "setting":
      icon = SettingOutlined;
      break;
  }

  return icon;
});

const iconStyle = computed(() => {
  /* if (props.icon === "download") {
    return {
      fontSize: "16px"
    };
  } */
  return { fontSize: "16px" };
});

const emit = defineEmits(["click"]);
const iconClick = (e: MouseEvent) => {
  emit("click", e);
};
</script>

<script lang="ts">
export default {
  name: "IconButton"
};
</script>

<style lang="less" scoped>
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #fff;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  &:hover {
    // background: #000000;
    background-color: rgba(0, 0, 0, 0.05);
    color: #333333;
    // opacity: 0.05;
  }
  &:focus {
    color: #333333;
  }
}
</style>
